import authApi from "../redux/authApi";
import { store } from "../redux/store";
import { showSnackbar } from "../redux/Slice/snackbar/snackbarSlice";

export const triggerPresignedDownload = (url, fileName) => {
  if (!url) return false;

  try {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = url;
    iframe.title = fileName || "download";
    document.body.appendChild(iframe);

    window.setTimeout(() => {
      try {
        iframe.remove();
      } catch (_) {}
    }, 60 * 1000);

    return true;
  } catch (_) {
    const a = document.createElement("a");
    a.href = url;
    a.rel = "noopener noreferrer";
    a.download = fileName || "download";
    document.body.appendChild(a);
    a.click();
    a.remove();
    return true;
  }
};

export const resolveFolderDownloadTarget = item => {
  if (!item) return { folderId: null, folderName: "TMS_", zipNameOverride: undefined };

  if (item.job_id && item.out_fmanager_id) {
    const folderName = item.name || item.job_number || "TMS_";
    return {
      folderId: item.out_fmanager_id,
      folderName,
      zipNameOverride: folderName,
    };
  }

  return {
    folderId: item.fmanager_id,
    folderName: item.name || "TMS_",
    zipNameOverride: undefined,
  };
};

export const downloadFolderAsZip = async ({
  folderId,
  folderName = "TMS_",
  zipNameOverride,
  onSuccess,
  onError,
}) => {
  if (!folderId) {
    const message = "Folder is not available for download.";
    store.dispatch(showSnackbar({ message, type: "error" }));
    onError?.(new Error(message));
    return;
  }

  try {
    const apiBase = authApi?.defaults?.baseURL || "";
    const zipName = zipNameOverride ?? folderName;
    const zipNameQuery =
      zipName && String(zipName).trim() ? `?zip_name=${encodeURIComponent(String(zipName).trim())}` : "";
    const endpoint = `${apiBase.replace(/\/$/, "")}/downloadFolderFast/${folderId}${zipNameQuery}`;

    const token = localStorage.getItem("token");
    const headers = { Accept: "application/json" };
    if (token) headers.Authorization = `Bearer ${token}`;

    const res = await fetch(endpoint, { method: "GET", headers });

    if (!res.ok) {
      let errMsg = `Download failed (HTTP ${res.status})`;
      try {
        const maybeJson = await res.json();
        errMsg = maybeJson?.msg || maybeJson?.error?.msg || errMsg;
      } catch (_) {}
      throw new Error(errMsg);
    }

    const data = await res.json();
    if (!data?.download_url) {
      throw new Error(data?.msg || "Invalid folder download response");
    }

    const responseFileName = data?.file_name || `${zipName || folderName}.zip`;
    triggerPresignedDownload(data.download_url, responseFileName);

    store.dispatch(
      showSnackbar({
        message: data?.msg || "Download started",
        type: "success",
      })
    );

    if (data?.missing_files?.length > 0) {
      alert(`Some files couldn't be downloaded:\n${data.missing_files.join("\n")}`);
    }

    onSuccess?.(data);
    return data;
  } catch (error) {
    store.dispatch(
      showSnackbar({
        message: error?.message || "Failed to download folder. Please try again.",
        type: "error",
      })
    );
    console.error("Failed to download folder:", error);
    onError?.(error);
    throw error;
  }
};

export const downloadJobFolderAsZip = async ({ folderId, jobName }) =>
  downloadFolderAsZip({
    folderId,
    folderName: jobName || "TMS_",
    zipNameOverride: jobName,
  });
